import debounce from 'lodash.debounce';
import axios from 'axios';

export default {
  data() {
    return {
      provinces: [],
      cities: [],
      subdistricts: [],
      villages: [],
      loadProvinces: false,
      loadCities: false,
      loadSubdistricts: false,
      loadVillages: false,
      searchProvinces: '',
      searchCities: '',
      searchSubdistricts: '',
      searchVillages: '',
      formAddressName: null,
      disabledCities: true,
      disabledSubdistricts: true,
      disabledVillages: true
    };
  },
  mounted() {
    this.getProvinces();
  },

  computed: {
    provinceWatcher() {
      return this[this.formAddressName].province;
    },
    cityWatcher() {
      return this[this.formAddressName].city;
    },
    subdistrictWatcher() {
      return this[this.formAddressName].subdistrict;
    }
  },
  watch: {
    provinceWatcher(after, before) {
      if (!this.defaultArea) {
        if (before && this.formAddressName) {
          this[this.formAddressName].city = null;
          this[this.formAddressName].subdistrict = null;
          this[this.formAddressName].village = null;
          this.disabledCities = true;
          this.disabledSubdistricts = true;
          this.disabledVillages = true;
        }
        if (after && after.id == 'all') {
          this.disabledCities = true;
        } else if (after) {
          this.disabledCities = false;
        }
        this.getCities();
      }
    },
    cityWatcher(after, before) {
      if (before && this.formAddressName) {
        this[this.formAddressName].subdistrict = null;
        this[this.formAddressName].village = null;
        this.disabledSubdistricts = true;
        this.disabledVillages = true;
      }
      if (after && after.id == 'all') {
        this.disabledSubdistricts = true;
      } else if (after) {
        this.disabledSubdistricts = false;
      }
      this.getSubdistricts();
    },
    subdistrictWatcher(after, before) {
      if (before && this.formAddressName) {
        this[this.formAddressName].village = null;
        this.disabledVillages = true;
      }
      if (after && after.id == 'all') {
        this.disabledVillages = true;
      } else if (after) {
        this.disabledVillages = false;
      }
      this.getVillages();
    },
    searchProvinces(val) {
      if (
        val &&
        (!this[this.formAddressName].province ||
          val !== this[this.formAddressName].province.provinceName)
      ) {
        this.getProvinces(val);
      }
    },
    searchCities(val) {
      if (
        !this[this.formAddressName].city ||
        val !== this[this.formAddressName].city.cityName
      ) {
        this.getCities(val);
      }
    },
    searchSubdistricts(val) {
      if (
        !this[this.formAddressName].subdistrict ||
        val !== this[this.formAddressName].subdistrict.subdistrictName
      ) {
        this.getSubdistricts(val);
      }
    },
    searchVillages(val) {
      if (
        !this[this.formAddressName].district ||
        val !== this[this.formAddressName].district.districtName
      ) {
        this.getVillages(val);
      }
    }
  },
  methods: {
    getProvinces: debounce(async function(name) {
      this.loadProvinces = true;
      try {
        const {
          data: { data }
        } = await axios.get(
          'https://api-v2-monsta-mls.monsta.id/api/regions/provinces',
          {
            headers: {
              Authorization:
                'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
            },
            params: {
              search: name
            }
          }
        );
        this.provinces = data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loadProvinces = false;
      }
    }, 500),

    getCities: debounce(async function(name) {
      if (
        this[this.formAddressName].province &&
        this[this.formAddressName].province.id != 'all'
      ) {
        this.loadCities = true;
        try {
          const {
            data: { data }
          } = await axios.get(
            `https://api-v2-monsta-mls.monsta.id/api/regions/provinces/${
              this[this.formAddressName].province.id
            }/cities`,
            {
              headers: {
                Authorization:
                  'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
              },
              params: {
                search: name
              }
            }
          );

          this.cities = data;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        } finally {
          this.loadCities = false;
        }
      }
    }, 500),

    getSubdistricts: debounce(async function(name) {
      if (
        this[this.formAddressName].city &&
        this[this.formAddressName].city.id != 'all'
      ) {
        this.loadSubdistricts = true;
        try {
          const {
            data: { data }
          } = await axios.get(
            `https://api-v2-monsta-mls.monsta.id/api/regions/cities/${
              this[this.formAddressName].city.id
            }/subdistricts`,
            {
              headers: {
                Authorization:
                  'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
              },
              params: {
                search: name
              }
            }
          );

          this.subdistricts = data;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        } finally {
          this.loadSubdistricts = false;
        }
      }
    }, 500),

    getVillages: debounce(async function(name) {
      if (
        this[this.formAddressName].subdistrict &&
        this[this.formAddressName].subdistrict.id != 'all'
      ) {
        this.loadVillages = true;
        try {
          const {
            data: { data }
          } = await axios.get(
            `https://api-v2-monsta-mls.monsta.id/api/regions/subdistricts/${
              this[this.formAddressName].subdistrict.id
            }/villages`,
            {
              headers: {
                Authorization:
                  'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
              },
              params: {
                search: name
              }
            }
          );

          this.villages = data;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        } finally {
          this.loadVillages = false;
        }
      }
    }, 500)
  }
};
